import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { IEmptyColumnProps } from './EmptyColumn.types';

import './EmptyColumn.styles.scss';

const { Text } = Typography;

const EmptyColumn = ({ showText, emptyText = 'common.noData', className = '' }: IEmptyColumnProps) => {
  const { t } = useTranslation();

  if (!showText) {
    return null;
  }

  return <Text className={`np-empty-column ${className}`}>{t(emptyText)}</Text>;
};

export default EmptyColumn;
